import { useTranslation } from '@root/shared/localization'
import { InfoMessage } from '@root/shared/ui-kit'

import { DistributionCommon } from './distribution-common'

import type { ClassNameProps } from '@root/shared/react'

type Props = {
  onRetry: () => void
} & ClassNameProps

export const DistributionError = (props: Props) => {
  const { t } = useTranslation()
  return (
    <DistributionCommon className={props.className}>
      <InfoMessage
        intent="error"
        title={t('common.error')}
        onRetry={props.onRetry}
        description={t('common.something_went_wrong_try_again')}
      />
    </DistributionCommon>
  )
}
